import { BloggerPost } from './mockData';

export const FETCHED_PAGES: BloggerPost[] = [
  {
    "id": "page1",
    "title": "আমাদের সম্পর্কে",
    "content": `<div class="shn-about-page">
    <div class="shn-hero">
        <div class="shn-hero-overlay"><div style="text-align: center;"><img alt="Seba Hot News Banner" class="shn-main-cover" src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiJzHI-8X9sqzwU-o-DlkixIh64qI0l_0jIUMV-lXJMtSRHPq8pIisbkyiUIp39fMOQc4Zgn4OOX3nA_RvlR9pgxk1PnlV5buGtrxaoKoX_cmFR7EJjUN0na_1Fu8g_0fLVl_pUFpK3iKxXo5zQW5kk8KPmtR4HTP-BBArIEGJ6iT8lgifsiWKk1TawbA/s16000/Seba-Hot-News-Cover-for-google-bussiness.jpg" /></div>
            <h1 class="shn-main-title">আমাদের সম্পর্কে</h1>
            <p class="shn-main-tagline">সেবা হট নিউজ | সত্য প্রকাশে আপোষহীন</p>
        </div>
    </div>

    <div class="shn-container">
        <div class="shn-stats-grid">
            <div class="stat-card">
                <span class="stat-icon">📈</span>
                <div class="stat-val">২ লক্ষ+</div>
                <div class="stat-lbl">মাসিক পাঠক</div>
            </div>
            <div class="stat-card">
                <span class="stat-icon">👥</span>
                <div class="stat-val">৩১ জন</div>
                <div class="stat-lbl">নিবেদিত কর্মী</div>
            </div>
            <div class="stat-card">
                <span class="stat-icon">📅</span>
                <div class="stat-val">২০১৫</div>
                <div class="stat-lbl">প্রতিষ্ঠাকাল</div>
            </div>
            <div class="stat-card">
                <span class="stat-icon">👍</span>
                <div class="stat-val">১৭০০০+</div>
                <div class="stat-lbl">ফেসবুক ফলোয়ার</div>
            </div>
        </div>

        <div class="shn-content-grid">
            <div class="shn-content-card">
                <h2 class="card-title">সেবা হট নিউজ পরিচিতি</h2>
                <div class="shn-text">
                    <p><strong>সেবা হট নিউজ</strong> একটি জনপ্রিয় বাংলা অনলাইন নিউজ পোর্টাল। ২০১৫ সালের ৭ই জুন থেকে এই সংবাদ মাধ্যমটি বিশ্বের সকল প্রান্তে ইন্টারনেট বা অন্তর্জালের মাধ্যমে বাংলা ভাষায় দেশ-বিদেশের খবর পরিবেশন করে আসছে।</p>
                    
                    <blockquote class="shn-quote">
                        "সত্য প্রকাশে আপোষহীন" - এই শিরোনাম ও শ্লোগান নিয়ে আমাদের পথচলা।
                    </blockquote>

                    <p>আমরা জাতীয়, রাজনীতি, ক্রীড়া, বিনোদন, বিজ্ঞান ও প্রযুক্তি সহ সকল বিষয়ের সংবাদ দ্রুততম সময়ে এবং নির্ভুলভাবে পরিবেশন করি। সারা বাংলাদেশে আমাদের ৩১ জন কর্মীর কঠোর পরিশ্রমে আমরা প্রতিদিন পাঠকদের তথ্য সেবা দিয়ে যাচ্ছি।</p>
                    
                    <h3>আমাদের শুভেচ্ছা</h3>
                    <p>আপনাদের অশেষ ভালোবাসায় সেবা হট নিউজ আজ একটি মাইলফলক অতিক্রম করেছে। পাঠকদের মতামত ও চাহিদাকে প্রাধান্য দিয়েই আমাদের এই অগ্রযাত্রা। আমরা বিশ্বাস করি, পত্রিকার মূল শক্তি তার পাঠক।</p>
                </div>
            </div>

            <div class="shn-content-card en-card">
                <h2 class="card-title">About Seba Hot News</h2>
                <div class="shn-text">
                    <p><strong>Seba Hot News</strong> is a leading online news portal providing up-to-date information in Bengali and English. Established in 2015, we are committed to unbiased and accurate reporting.</p>
                    
                    <div class="vision-box">
                        <h4>Our Vision</h4>
                        <p>With cutting-edge outlook and futuristic vision for info-savvy generations, we provide the most credible information in real-time.</p>
                    </div>

                    <p>Our platform covers politics, sports, business, and technology with insightful analysis. We strive to be a trusted source for millions of readers globally.</p>
                </div>
            </div>
        </div>

        <div class="shn-impressum">
            <h2 class="text-center">Impressum / সংক্ষিপ্ত বিবরণ</h2>
            <div class="impressum-grid">
                <div class="imp-item">
                    <strong>📍 Address:</strong>
                    <p>Islamic Mission Road, Bakshiganj-2140, Jamalpur, Mymensingh, Bangladesh.</p>
                </div>
                <div class="imp-item">
                    <strong>📧 Email:</strong>
                    <p>info@sebahotnews.com</p>
                </div>
                <div class="imp-item">
                    <strong>📞 Phone:</strong>
                    <p>+880 1711 986 954</p>
                </div>
                <div class="imp-item">
                    <strong>👨💼 Owner:</strong>
                    <p>S M Ashraful Azom</p>
                </div>
            </div>
        </div>
    </div>
</div>`,
    "url": "/p/about-us.html",
    "published": "2026-05-14T09:46:54.185Z",
    "updated": "2026-05-14T09:46:54.185Z",
    "author": {
      "displayName": "Admin"
    }
  },
  {
    "id": "page2",
    "title": "Contact Us",
    "content": `<div class="shn-contact-wrapper">
    <div class="shn-container">
        <div class="shn-header">
            <h2>Contact Us Directly</h2>
            <p>Please use the form below to get in touch with us for any inquiries.</p>
        </div>

        <div class="shn-grid">
            <div class="shn-info-card">
                <div class="info-item">
                    <span class="icon">🏢</span>
                    <div id="Our Office">
                        <h4>Our Office</h4>
                        <p><a href="https://maps.app.goo.gl/LvJLrFdnW5auxWPo6" target="_blank">Seba Hot News, Jamalpur, Bangladesh.</a></p>
                    </div>
                </div>
                <div class="info-item">
                    <span class="icon">📧</span>
                    <div id="Email">
                        <h4>Email</h4>
                        <p>info@sebahotnews.com</p>
                    </div>
                </div>
                <div class="info-item">
                    <span class="icon">📱</span>
                    <div id="HotLine">
                        <h4>Hotline</h4>
                        <p>+880 1711-986954</p>
                    </div>
                </div>
            </div>

            <div class="shn-form-card">
                <form id="shnCustomForm">
                    <div class="form-row">
                        <div class="form-group">
                            <label>Your Name</label>
                            <input name="name" required="" type="text" />
                        </div>
                        <div class="form-group">
                            <label>Email Address</label>
                            <input name="email" required="" type="email" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Subject</label>
                        <input name="subject" placeholder="What is this about?" required="" type="text" />
                    </div>
                    <div class="form-group">
                        <label>Message</label>
                        <textarea name="message" required="" rows="4"></textarea>
                    </div>
                    <button class="shn-btn" id="submitBtn" type="submit">Send Message</button>
                    <div class="shn-msg" id="responseMsg"></div>
                </form>
            </div>
        </div>

        <div class="shn-map-box" id="Location">
                   <iframe allowfullscreen="" height="350" loading="lazy" referrerpolicy="no-referrer-when-downgrade" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.522995285294!2d89.86354037538138!3d25.18557947771843!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39fd65e10eb13e2f%3A0xd750f3acc439a1e1!2zU2ViYSBIb3QgTmV3cyDgprjgp4fgpqzgpr4g4Ka54KafIOCmqOCmv-CmieCmnA!5e0!3m2!1sen!2sbd!4v1773489605373!5m2!1sen!2sbd" style="border: 0;" width="100%"></iframe>
          
        </div>
    </div>
</div>`,
    "url": "/p/contact-us.html",
    "published": "2026-05-14T09:46:54.185Z",
    "updated": "2026-05-14T09:46:54.185Z",
    "author": {
      "displayName": "Admin"
    }
  },
  {
    "id": "page3",
    "title": "Privacy Policy",
    "content": `<div class="shn-policy-wrapper">
    <div class="shn-policy-header">
        <div class="header-overlay">
            <img alt="Seba Hot News Logo" loading="lazy" src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhregPnbJ6RRcZ98oqo4Uoadn9ife9y4DWlide9vGdca7gbKXPrsZDAo20mp2pJVeVNvhHmp0Sl9g3ktuJ-poVZLsJRtxl-dgrXUyH2Dfgn8auW1tmXNHR3HKqZ9EO6E9_DwhEgfmKa6hvzzhe4wIIC5QoU-62kmyWGJiq8y9uXI6K5fh2qcX4_oqeaVA/s16000-rw/Sebahotnews%20Logo___Vector__1.webp" />
            <h1>Privacy Policy</h1>
            <p>Effective Date: May 15, 2024 (Updated for 2026)</p>
        </div>
    </div>

    <div class="shn-container">
        <div class="shn-policy-body">
            <p class="intro-text">At <strong>Seba Hot News</strong>, we are committed to protecting your privacy. This policy explains how we collect, use, and safeguard your personal data when you visit our portal.</p>

            <section>
                <h2>1. Information We Collect</h2>
                <div class="info-grid">
                    <div class="info-box">
                        <strong>Personal Data:</strong>
                        <p>Name, Email Address, and Phone Number provided during registration or newsletters.</p>
                    </div>
                    <div class="info-box">
                        <strong>Usage Data:</strong>
                        <p>IP Address, Browser Type, and Pages visited (collected automatically via Cookies).</p>
                    </div>
                </div>
            </section>

            <section>
                <h2>2. How We Use Your Information</h2>
                <ul>
                    <li>To provide latest news updates and manage your account.</li>
                    <li>To improve website performance and user experience.</li>
                    <li>To send newsletters and informative communications.</li>
                    <li>To comply with legal obligations of the People's Republic of Bangladesh.</li>
                </ul>
            </section>

            <section>
                <h2>3. Cookies & Tracking Technologies</h2>
                <p>We use Cookies to enhance your browsing experience. This helps us remember your preferences and analyze traffic patterns. You can disable cookies through your browser settings, though some features may not function properly.</p>
            </section>

            <section>
                <h2>4. Third-Party Links & Services</h2>
                <p>Our service may contain links to external sites (like Google Adsense or Social Media). We do not control their privacy practices and advise you to review their policies separately.</p>
            </section>

            <section>
                <h2>5. Data Security</h2>
                <p>We implement commercially acceptable security measures to protect your data. However, please note that no method of online transmission is 100% secure.</p>
            </section>

            <section id="contact-info">
                <h2>6. Contact Us</h2>
                <div class="contact-panel">
                    <p>📧 <strong>Email:</strong> <a href="mailto:info@sebahotnews.com">info@sebahotnews.com</a></p>
                    <p>📞 <strong>Phone:</strong> +88 01711986954</p>
                    <p>🌐 <strong>Website:</strong> <a href="https://www.sebahotnews.com/p/contact-us.html">Contact Page</a></p>
                </div>
            </section>
        </div>
    </div>
</div>`,
    "url": "/p/privacy-policy.html",
    "published": "2026-05-14T09:46:54.186Z",
    "updated": "2026-05-14T09:46:54.186Z",
    "author": {
      "displayName": "Admin"
    }
  }
];
